import dayjs from 'dayjs';
import { BuyerDocumentResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-document-response.dto';
import { Action, Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';
import { FC } from 'react';

interface OrganizationDocumentOrganismProps {
  documents: BuyerDocumentResponseDto[];
  handleDelete: (id: string) => void;
  handleEdit: (id: string) => void;
  handleDownload: (id: string) => void;
}

const OrganizationDocumentOrganism: FC<OrganizationDocumentOrganismProps> = ({
  documents,
  handleDelete,
  handleEdit,
  handleDownload,
}) => {
  return (
    <SortableTable
      data={documents}
      columns={[
        { label: 'Document name', key: 'name' },
        { label: 'File', key: 'file' },
        { label: 'Date-time Created', key: 'createdOnDateTimeUtc' },
        { label: '' },
      ]}
      renderRow={(document) => (
        <TableRow key={document.id}>
          <Label content={document.name ?? undefined}></Label>
          <Label content={document.file ?? undefined}></Label>
          <Label
            content={
              dayjs(document.createdOnDateTimeUtc)
                .format('YYYY-MM-DD HH:mm:ss')
                .toString() ?? undefined
            }
          />
          <Action
            type="edit"
            size="sm"
            onClick={() => handleEdit(document.id)}
          ></Action>
          <Action
            type="download"
            size="sm"
            onClick={() => handleDownload(document.id)}
          ></Action>
          <Action
            type="delete"
            size="sm"
            onClick={() => handleDelete(document.id)}
          ></Action>
        </TableRow>
      )}
    />
  );
};

export default OrganizationDocumentOrganism;
